module.exports = __webpack_public_path__ + "media/images/icon-svg/cart-3-5df4f568fa011e581021979a5206e16c.svg";